export default [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    redirect: "/login",
    meta: {
      title: "Dashboard",
      guest: true,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/dashboard/Index.vue"),
    meta: {
      auth: true,
      title: "Dashboard",
    },
  },
  {
    path: "/calendar",
    name: "calendar",
    component: () => import("../views/appointment/calendarMiddleware.vue"),
    meta: {
      auth: true,
      title: "Calendar",
    },
  },
  {
    path: "/group-sessions",
    component: () => import("../views/admin/group-sessions/Index"),
    meta: {
      auth: true,
      noClient: true,
      title: "Group Sessions",
    },
    children: [
      {
        path: "",
        name: "group-sessions",
        component: () => import("../views/admin/group-sessions/SessionsList"),
        meta: {
          title: "Group Sessions",
        },
      },
      {
        path: "create",
        name: "group-sessions.create",
        component: () => import("../views/admin/group-sessions/Create"),
        meta: {
          title: "Create Group Session",
        },
      },
      {
        path: ":id",
        name: "group-sessions.detail",
        component: () => import("../views/admin/group-sessions/SessionDetail"),
        meta: {
          title: "Group Session Details",
        },
      },
      {
        path: ":id/edit",
        name: "group-sessions.edit",
        component: () => import("../views/admin/group-sessions/Create"),
        meta: {
          title: "Edit Group Session",
        },
      },
    ],
  },
  {
    path: "/group-sessions/:sessionId/bulk-clinical-notes",
    name: "groupSessions.bulkClinicalNotes",
    component: () =>
      import("../views/appointment/components/BulkClinicalNoteCreate.vue"),
    meta: {
      auth: true,
      noClient: true,
      title: "Bulk Clinical Notes",
    },
  },
  {
    path: "/group-sessions/:sessionId/bulk-engagement-notes",
    name: "groupSessions.bulkEngagementNotes",
    component: () =>
      import("../views/appointment/components/BulkEngagementNoteCreate.vue"),
    meta: {
      auth: true,
      noClient: true,
      title: "Bulk Engagement Notes",
    },
  },
  {
    path: "/old-calendar",
    name: "old-calendar",
    component: () => import("../views/appointment/oldCalendarMiddleware.vue"),
    meta: {
      auth: true,
      title: "Old Calendar",
    },
  },
  {
    path: "/tasks",
    component: () => import("../views/tasks/Tabs.vue"),
    meta: {
      auth: true,
      title: "Tasks",
    },
    children: [
      {
        path: "",
        name: "Tasks",
        component: () => import("../views/tasks/Index.vue"),
      },
      {
        path: "drafts",
        name: "drafts",
        component: () => import("../views/tasks/Drafts.vue"),
      },
    ],
  },
  {
    path: "/tasks/create",
    name: "tasks.add",
    component: () => import("../views/tasks/Create.vue"),
    meta: {
      auth: true,
      title: "Create Tasks",
    },
  },
  {
    path: "/tasks/update/:id",
    name: "tasks.update",
    component: () => import("../views/tasks/Create.vue"),
    meta: {
      auth: true,
      title: "Update Tasks",
    },
  },
  {
    path: "/tasks/drafts/:id",
    name: "drafts.update",
    component: () => import("../views/tasks/DraftUpdate.vue"),
    meta: {
      auth: true,
      title: "Update Draft",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/Login.vue"),
    meta: {
      title: "Login",
      guest: true,
    },
  },
  {
    path: "/reset-password",
    name: "ForgotPasswordForm",
    component: () => import("../views/auth/ForgotPassword.vue"),
    meta: {
      auth: false,
      guest: true,
      title: "Forgot Password",
    },
  },
  {
    path: "/reset-password/:token",
    name: "ResetPasswordForm",
    component: () => import("../views/auth/ResetPassword.vue"),
    meta: {
      auth: false,
    },
  },
  {
    path: "/rooms",
    name: "rooms",
    component: () => import("../views/meetingRooms/Index.vue"),
    meta: {
      auth: true,
      title: "Meeting Rooms",
    },
  },
  {
    path: "/rooms/recordings",
    name: "rooms.all-recordings",
    component: () => import("../views/meetingRooms/RoomsRecordings.vue"),
    meta: {
      auth: true,
      noClient: true,
      title: "Rooms Recordings & Transcripts",
    },
  },
  {
    path: "/rooms/create",
    name: "rooms.create",
    component: () => import("../views/meetingRooms/Create.vue"),
    meta: {
      auth: true,
      noClient: true,
      title: "Create Meeting Room",
    },
  },
  {
    path: "/rooms/:id/recordings",
    name: "rooms.recordings",
    component: () => import("../views/meetingRooms/Recordings.vue"),
    meta: {
      auth: true,
      noClient: true,
      title: "Recordings & Transcripts",
    },
  },
  {
    path: "/rooms/:slug",
    name: "room",
    component: () => import("../views/public/Room.vue"),
    meta: {
      public: true,
      title: "Meeting Room",
    },
  },
  {
    path: "/clinical-notes/:token",
    name: "clinical-note",
    component: () => import("../views/public/ClinicalNote.vue"),
    meta: {
      public: true,
      title: "Clinical Note",
    },
  },
  {
    path: "/invoices/:token",
    name: "invoice",
    component: () => import("../views/public/Invoice.vue"),
    meta: {
      public: true,
      title: "Invoice",
    },
  },
  {
    path: "/okaya-return",
    name: "okaya-return",
    component: () => import("../views/public/OkayaReturn.vue"),
    meta: {
      public: true,
      title: "Okaya",
    },
  },
  {
    path: "/booking",
    name: "booking",
    component: () => import("../views/public/Booking.vue"),
    meta: {
      public: true,
      title: "Booking",
    },
  },
  {
    path: "/booking/:providerId",
    name: "booking.providerId",
    component: () => import("../views/public/Booking.vue"),
    meta: {
      public: true,
      title: "Booking",
    },
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import("../views/public/Maintenance.vue"),
    meta: {
      public: true,
      title: "Maintenance",
    },
  },
  {
    path: "/booking-requests",
    name: "booking-requests",
    component: () => import("../views/booking-requests/Index.vue"),
    meta: {
      auth: true,
      title: "Booking Requests",
    },
  },
  {
    path: "/booking-requests/:id",
    name: "booking-requests.view",
    component: () => import("../views/booking-requests/Edit.vue"),
    meta: {
      auth: true,
      title: "Booking Request",
    },
  },
  {
    path: "/documents/:id/preview",
    name: "documents.preview",
    component: () => import("../views/documents/DocumentPreview.vue"),
    meta: {
      auth: true,
      title: "Document Preview",
    },
  },
];
